export default {
  municipalitiesData: [],
  cities:[],
  regions:[]
}
